// ABOUTME: Renders the app's shared English/Hawaiian-trail label pattern (Hawaiian-lead available on request)
// ABOUTME: mode="english-lead" (default) leads with English; "bilingual" leads with Hawaiian; "english" omits Hawaiian

import React from 'react';
import { Box } from '@mui/material';
import { bilingualGlossary, BilingualTerm } from '../utils/bilingualGlossary';

export interface BilingualLabelProps {
  term: BilingualTerm;
  english: string;
  mode?: 'bilingual' | 'english-lead' | 'english';
}

export const BilingualLabel: React.FC<BilingualLabelProps> = ({ term, english, mode = 'english-lead' }) => {
  const hawaiian = bilingualGlossary[term as keyof typeof bilingualGlossary] as string | undefined;

  if (!hawaiian || mode === 'english') {
    return <>{english}</>;
  }

  if (mode === 'english-lead') {
    return (
      <Box component="span">
        <Box component="span">{english}</Box>
        <Box component="span" data-testid="bilingual-trail" sx={{ fontStyle: 'italic', fontWeight: 500 }}>
          {' · '}{hawaiian}
        </Box>
      </Box>
    );
  }

  return (
    <Box component="span">
      <Box component="span" sx={{ fontWeight: 800 }}>{hawaiian}</Box>
      {' · '}
      <Box component="span">{english}</Box>
    </Box>
  );
};
